<template>
  <div class="auth">
    <aside class="auth-brand" aria-hidden="true">
      <div class="brand-pattern"></div>
      <div class="brand-inner">
        <div class="brand-mark">
          <img :src="require('@/assets/images/logo.png')" alt="">
          <span>التحضير الذكي</span>
        </div>
        <h1>يومك الدراسي كاملاً<br>في لوحة واحدة</h1>
        <p class="brand-lead">حضور الطلاب والمعلمين، إشعارات أولياء الأمور، والتقارير لحظة بلحظة.</p>

        <!-- Illustration of the product, not the viewer's data -->
        <div class="preview">
          <div class="preview-head">
            <span>تحضير اليوم</span>
            <small>مثال توضيحي</small>
          </div>
          <div class="preview-body">
            <div class="ring" style="--p: 88">
              <b>88%</b>
              <small>الحضور</small>
            </div>
            <ul>
              <li><i class="dot ok"></i>حاضر <b>612</b></li>
              <li><i class="dot late"></i>متأخر <b>38</b></li>
              <li><i class="dot bad"></i>غائب <b>41</b></li>
            </ul>
          </div>
          <div class="preview-foot"><i class="fa fa-bell"></i> وصل إشعار الغياب لـ 41 ولي أمر</div>
        </div>

        <ul class="brand-points">
          <li><i class="fa fa-check-circle"></i> تحضير بالبصمة والباركود والجوال</li>
          <li><i class="fa fa-check-circle"></i> تطبيقات للمدرسة والمعلم وولي الأمر</li>
          <li><i class="fa fa-check-circle"></i> رسائل واتساب وSMS وإشعارات فورية</li>
        </ul>
      </div>
    </aside>

    <main class="auth-main">
      <div class="auth-card">
        <img class="auth-logo" :src="require('@/assets/images/banner.png')" alt="التحضير الذكي">
        <h2 class="auth-title">{{ title }}</h2>
        <p v-if="subtitle" class="auth-sub">{{ subtitle }}</p>
        <slot></slot>
      </div>
      <p class="auth-foot">© التحضير الذكي · <a href="https://tahdir.net" target="_blank" rel="noopener">tahdir.net</a></p>
    </main>
  </div>
</template>

<script>
// Frame of the sign-in pages (login, teacher login, reset, register, activate): brand panel +
// form card. Pages keep their own fields and logic and use the .auth-* classes below.
export default {
  props: {
    title: { type: String, required: true },
    subtitle: { type: String, default: '' },
  },
};
</script>

<style>
/* Not scoped: the pages' own fields (slot content) use these classes.
   Left / right are written in LTR terms: postcss-rtl flips them for the Arabic page. */
.auth {
  --a-ink: #0F1733;
  --a-text: #344054;
  --a-muted: #667085;
  --a-line: #D5DAE3;
  --a-field: #C4CBD6;
  --a-p: #1D4ED8;
  --a-pd: #1E3A8A;
  --a-navy: #0B1640;
  --a-gold: #F5A30B;
  --a-ok: #12B76A;
  --a-late: #F79009;
  --a-bad: #F04438;
  min-height: 100vh;
  display: flex;
  background: #F2F4F9;
  color: var(--a-text);
}

/* ---------- brand panel ---------- */
.auth-brand {
  position: relative;
  flex: 0 0 46%;
  max-width: 640px;
  overflow: hidden;
  color: #fff;
  background:
    radial-gradient(120% 80% at 85% 0%, rgba(59, 130, 246, 0.55) 0%, transparent 60%),
    radial-gradient(80% 60% at 0% 100%, rgba(245, 163, 11, 0.18) 0%, transparent 60%),
    linear-gradient(160deg, var(--a-pd) 0%, var(--a-navy) 70%);
}
.brand-pattern {
  position: absolute;
  inset: 0;
  opacity: 0.09;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='88' height='88' viewBox='0 0 88 88'%3E%3Cg fill='none' stroke='%23fff' stroke-width='1.2'%3E%3Crect x='24' y='24' width='40' height='40'/%3E%3Crect x='24' y='24' width='40' height='40' transform='rotate(45 44 44)'/%3E%3Ccircle cx='44' cy='44' r='9'/%3E%3Cpath d='M0 44h8M80 44h8M44 0v8M44 80v8'/%3E%3C/g%3E%3C/svg%3E");
  background-size: 88px 88px;
}
.brand-inner {
  position: relative;
  height: 100%;
  padding: 48px 56px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 22px;
}
.brand-mark {
  display: flex;
  align-items: center;
  gap: 12px;
  font-weight: 800;
  font-size: 18px;
}
.brand-mark img {
  width: 54px;
  height: 54px;
  filter: drop-shadow(0 8px 14px rgba(0, 0, 0, 0.3));
}
.auth-brand h1 {
  color: #fff;
  font-size: 34px;
  font-weight: 800;
  line-height: 1.45;
  margin: 0;
  text-wrap: balance;
}
.brand-lead {
  margin: 0;
  font-size: 15px;
  line-height: 1.9;
  color: rgba(255, 255, 255, 0.8);
  max-width: 440px;
}
.preview {
  width: 100%;
  max-width: 380px;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.18);
  border-radius: 20px;
  padding: 16px 18px;
  backdrop-filter: blur(8px);
  box-shadow: 0 24px 50px -20px rgba(0, 0, 0, 0.45);
  animation: auth-float 7s ease-in-out infinite;
}
.preview-head {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  font-weight: 700;
}
.preview-head small {
  color: rgba(255, 255, 255, 0.55);
  font-weight: 400;
  font-size: 11px;
}
.preview-body {
  display: flex;
  align-items: center;
  gap: 20px;
  margin: 14px 0 12px;
}
.ring {
  --deg: calc(var(--p) * 3.6deg);
  width: 92px;
  height: 92px;
  flex: none;
  border-radius: 50%;
  display: grid;
  place-content: center;
  text-align: center;
  background:
    radial-gradient(closest-side, #16255F 78%, transparent 80%),
    conic-gradient(var(--a-ok) var(--deg), rgba(255, 255, 255, 0.14) 0);
}
.ring b {
  font-size: 20px;
  line-height: 1;
}
.ring small {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.7);
}
.preview-body ul {
  list-style: none;
  padding: 0;
  margin: 0;
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-size: 14px;
}
.preview-body li {
  display: flex;
  align-items: center;
  gap: 8px;
}
.preview-body li b {
  margin-left: auto;
  font-variant-numeric: tabular-nums;
}
.dot {
  width: 9px;
  height: 9px;
  border-radius: 50%;
}
.dot.ok { background: var(--a-ok); }
.dot.late { background: var(--a-late); }
.dot.bad { background: var(--a-bad); }
.preview-foot {
  font-size: 12.5px;
  padding-top: 10px;
  border-top: 1px solid rgba(255, 255, 255, 0.14);
  color: rgba(255, 255, 255, 0.82);
}
.preview-foot i {
  color: var(--a-gold);
  margin-right: 4px;
}
.brand-points {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.85);
}
.brand-points i {
  color: var(--a-gold);
  margin-right: 6px;
}

/* ---------- form side ---------- */
.auth-main {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 32px 20px 20px;
}
.auth-card {
  width: 100%;
  max-width: 440px;
  background: #fff;
  border: 1px solid var(--a-line);
  border-radius: 24px;
  padding: 30px 28px 26px;
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.05), 0 30px 60px -34px rgba(15, 23, 51, 0.35);
  animation: auth-rise 0.45s ease-out both;
}
.auth-logo {
  display: block;
  height: 40px;
  width: auto;
  margin-bottom: 22px;
}
.auth-title {
  color: var(--a-ink);
  font-size: 23px;
  font-weight: 800;
  margin: 0 0 6px;
}
.auth-sub {
  color: var(--a-muted);
  font-size: 14px;
  line-height: 1.8;
  margin: 0 0 20px;
}
.auth-field {
  display: block;
  margin: 0 0 16px;
}
.auth-label {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  font-weight: 700;
  font-size: 13.5px;
  color: var(--a-ink);
  margin-bottom: 7px;
}
.auth-label a {
  font-weight: 400;
  font-size: 12.5px;
}
.auth-label small {
  font-weight: 400;
  font-size: 12px;
  color: var(--a-muted);
}
.auth-input {
  position: relative;
  display: flex;
  align-items: center;
  background: #fff;
  border: 1.5px solid var(--a-field);
  border-radius: 14px;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}
.auth-input:focus-within {
  border-color: var(--a-p);
  box-shadow: 0 0 0 4px rgba(29, 78, 216, 0.14);
}
.auth-input > i {
  width: 44px;
  flex: none;
  text-align: center;
  color: #98A2B3;
  font-size: 17px;
}
.auth-input input,
.auth-input select {
  flex: 1;
  min-width: 0;
  height: 50px;
  border: 0;
  outline: 0;
  background: transparent;
  font-size: 15px;
  color: var(--a-ink);
  padding: 0 14px 0 0;
  font-family: inherit;
}
.auth-input select {
  cursor: pointer;
}
.auth-input input::placeholder {
  color: #A9B1BF;
}
.auth-input .auth-eye {
  border: 0;
  background: none;
  width: 44px;
  height: 44px;
  color: #98A2B3;
  cursor: pointer;
}
.auth-input .auth-eye:hover {
  color: var(--a-p);
}
.auth-input.code input {
  text-align: center;
  letter-spacing: 0.5em;
  font-size: 22px;
  font-weight: 800;
  padding: 0;
}
.auth-btn {
  width: 100%;
  height: 52px;
  border: 0;
  border-radius: 14px;
  background: linear-gradient(135deg, var(--a-p), var(--a-pd));
  color: #fff;
  font-weight: 800;
  font-size: 16px;
  font-family: inherit;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  box-shadow: 0 14px 26px -14px rgba(29, 78, 216, 0.85);
  transition: transform 0.12s ease, box-shadow 0.12s ease, opacity 0.12s ease;
}
.auth-btn:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 18px 30px -14px rgba(29, 78, 216, 0.9);
}
.auth-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  box-shadow: none;
}
.auth-btn.green {
  background: linear-gradient(135deg, #12B76A, #067647);
  box-shadow: 0 14px 26px -14px rgba(7, 148, 85, 0.85);
}
.auth-btn:focus-visible,
.auth-ghost:focus-visible,
.auth-eye:focus-visible {
  outline: 3px solid rgba(29, 78, 216, 0.45);
  outline-offset: 2px;
}
.auth-ghost {
  width: 100%;
  height: 46px;
  margin-top: 10px;
  border: 1.5px solid var(--a-line);
  border-radius: 14px;
  background: #fff;
  color: var(--a-text);
  font-weight: 700;
  font-family: inherit;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}
.auth-ghost:hover {
  background: #F6F7FB;
  text-decoration: none;
  color: var(--a-ink);
}
.auth-alert {
  border-radius: 12px;
  padding: 11px 14px;
  font-size: 13.5px;
  line-height: 1.7;
  margin-bottom: 16px;
  display: flex;
  gap: 8px;
  align-items: flex-start;
}
.auth-alert i {
  margin-top: 4px;
}
.auth-alert.bad {
  background: #FEF3F2;
  color: #B42318;
  border: 1px solid #FECDCA;
}
.auth-alert.ok {
  background: #ECFDF3;
  color: #067647;
  border: 1px solid #ABEFC6;
}
.auth-alert.warn {
  background: #FFFAEB;
  color: #B54708;
  border: 1px solid #FEDF89;
}
.auth-check {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  font-size: 13.5px;
  margin: 4px 0 18px;
  cursor: pointer;
  font-weight: 500;
  color: var(--a-text);
}
.auth-check input {
  width: 18px;
  height: 18px;
  margin-top: 3px;
  accent-color: var(--a-p);
}
.auth-alt {
  text-align: center;
  font-size: 14px;
  color: var(--a-muted);
  margin: 18px 0 0;
}
.auth-alt a {
  font-weight: 700;
}
.auth-alt.muted {
  font-size: 12.5px;
  margin-top: 8px;
}
.auth-divider {
  display: flex;
  align-items: center;
  gap: 12px;
  color: #98A2B3;
  font-size: 12.5px;
  margin: 18px 0 4px;
}
.auth-divider::before,
.auth-divider::after {
  content: '';
  flex: 1;
  border-top: 1px solid var(--a-line);
}
.auth-steps {
  display: flex;
  gap: 8px;
  margin: -6px 0 18px;
}
.auth-steps span {
  flex: 1;
  height: 5px;
  border-radius: 3px;
  background: #E6E9EF;
}
.auth-steps span.on {
  background: var(--a-p);
}
.auth-foot {
  margin: 18px 0 0;
  font-size: 12.5px;
  color: #98A2B3;
}

@keyframes auth-rise {
  from { opacity: 0; transform: translateY(12px); }
  to { opacity: 1; transform: none; }
}
@keyframes auth-float {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-8px); }
}
@media (prefers-reduced-motion: reduce) {
  .auth-card, .preview { animation: none; }
}

/* ---------- phones and tablets ---------- */
@media (max-width: 991.98px) {
  .auth {
    flex-direction: column;
  }
  .auth-brand {
    flex: none;
    max-width: none;
  }
  .brand-inner {
    padding: 22px 20px 70px;
    gap: 10px;
  }
  .auth-brand h1 {
    font-size: 22px;
  }
  .brand-lead {
    font-size: 13px;
    line-height: 1.8;
  }
  .brand-mark img {
    width: 40px;
    height: 40px;
  }
  .preview,
  .brand-points {
    display: none;
  }
  .auth-main {
    justify-content: flex-start;
    margin-top: -52px;
    padding: 0 16px 20px;
  }
  .auth-card {
    padding: 24px 20px 22px;
    border-radius: 22px;
  }
  .auth-logo {
    display: none;
  }
}
@media (max-width: 575.98px) {
  .brand-lead {
    display: none;
  }
}
</style>
